import { sklikRoutePlan } from "~/util/sklik";

export function setStartRequestState(routeState) {
	const itms = Mapy.CML.state.route.items;

	// vymazani uzavirek, aby nedoslo k spojeni objektu
	if (itms && itms.length) {
		itms.forEach(item => {
			item.closures = [];
			item.warnings = [];
		});
	}

	if (!routeState.fromHistory) {
		sklikRoutePlan();
	}

	// stav nacitani
	Mapy.CML.state = {
		route: {
			loading: true,
			request: true,
			trafficLoaded: false,
			traffic: {},
			error: "",
			// kdyz se nacita itinerar, tak nechame routing id, jinak je treba ho promazat
			routingId: routeState.itinerary ? routeState.routingId : undefined,
			items: itms,
			responseData: [],
			fromHistory: false,
			active: true,
			pubtv3: [],
		},
	};
}

export function clearTimeFromDate(date: Date) {
	date.setHours(0);
	date.setMinutes(0);
	date.setSeconds(0);
	date.setMilliseconds(0);
}

export function getDayDiff(time: number, past = false): number {
	const diffDate = new Date();
	const tmpDate = new Date(time);

	clearTimeFromDate(diffDate);
	clearTimeFromDate(tmpDate);

	const diff = Math[past ? "floor" : "ceil"]((tmpDate.getTime() - diffDate.getTime()) / 24 / 60 / 60 / 1000);

	return diff;
}
